import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, unref as _unref, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-mb-3 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-text-sm tw-text-slate-600" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_3 = ["value", "onChange"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-p-3 sm:tw-p-4" }
const _hoisted_6 = { class: "tw-overflow-x-auto" }
const _hoisted_7 = { class: "tw-min-w-full tw-border-separate tw-border-spacing-0 tw-text-left" }
const _hoisted_8 = { class: "tw-divide-y tw-divide-slate-200/70" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "tw-px-3 tw-py-3 tw-text-sm tw-font-semibold tw-text-slate-900" }
const _hoisted_11 = { class: "tw-px-3 tw-py-3 tw-text-sm tw-text-slate-700" }
const _hoisted_12 = { class: "tw-px-3 tw-py-3 tw-text-right" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "tw-mt-4 tw-flex tw-items-center tw-justify-between tw-text-sm tw-text-slate-600" }
const _hoisted_16 = {
  key: 0,
  class: "tw-mt-4 tw-flex tw-justify-center"
}

import { computed, ref, watch } from 'vue';
import { useQuery } from '@vue/apollo-composable';

import VesselsPaginatedQuery from '@/gql/orders/VesselsPaginated.gql';
import EditVessel from '@/components/Vessel/EditVessel.vue';
import PaginationBar from '@/components/core/PageElements/PaginationBar.vue';
import ListPage from '@/components/core/ListPage.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileVesselsTab',
  setup(__props) {

const isModalOpen = ref(false);
const selectedVessel = ref<any | null>(null);
const page = ref(0);
const pageSize = ref(10);
const searchQuery = ref('');

const queryVariables = computed(() => ({
  pageNum: page.value,
  pageSize: pageSize.value,
  searchQuery: searchQuery.value.trim() || null,
}));

const { result, loading, refetch } = useQuery(VesselsPaginatedQuery, queryVariables);
const vessels = computed(() => result.value?.vesselsPaginated || []);
const totalCount = computed(() => Number(result.value?.vesselsCount || 0));
const totalPages = computed(() => Math.max(1, Math.ceil(totalCount.value / pageSize.value)));

watch(pageSize, () => {
  page.value = 0;
});

watch(searchQuery, () => {
  page.value = 0;
});

watch([totalCount, loading], ([count, isLoading]) => {
  // Do not clamp while a new page request is in-flight, otherwise we can
  // reset page back to 0 and cancel the just-triggered request.
  if (isLoading) return;
  if (!count) {
    page.value = 0;
    return;
  }
  const maxPage = Math.max(0, Math.ceil(count / pageSize.value) - 1);
  if (page.value > maxPage) {
    page.value = maxPage;
  }
});

function openCreate() {
  selectedVessel.value = null;
  isModalOpen.value = true;
}

function openEdit(vessel: any) {
  selectedVessel.value = vessel;
  isModalOpen.value = true;
}

function closeModal() {
  isModalOpen.value = false;
}

async function refresh() {
  await refetch(queryVariables.value);
}

function prevPage() {
  if (page.value > 0) page.value -= 1;
}

function nextPage() {
  if (page.value + 1 < totalPages.value) page.value += 1;
}

function goToPage(nextPage: number) {
  if (nextPage < 0 || nextPage >= totalPages.value) return;
  page.value = nextPage;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListPage, {
    variant: "card",
    class: "tw-p-4 sm:tw-p-6",
    pageSize: pageSize.value,
    "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageSize).value = $event))
  }, {
    default: _withCtx(({ pageSizeOptions, setPageSize }) => [
      _createElementVNode("div", { class: "tw-mb-4 tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between" }, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tw-text-left" }, [
          _createElementVNode("h3", { class: "tw-text-lg tw-font-semibold tw-text-slate-900" }, "Vessels"),
          _createElementVNode("div", { class: "tw-mt-1 tw-text-sm tw-text-slate-600" }, "Manage vessel names used in orders.")
        ], -1)),
        _createElementVNode("button", {
          type: "button",
          class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800",
          onClick: openCreate
        }, " Add vessel ")
      ]),
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
          type: "text",
          placeholder: "Search vessel name...",
          class: "tw-h-10 tw-w-full sm:tw-w-80 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/70 tw-px-3 tw-text-sm tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/30"
        }, null, 512), [
          [_vModelText, searchQuery.value]
        ]),
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("span", null, "Rows", -1)),
          _createElementVNode("select", {
            class: "tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-px-2 tw-py-1 tw-text-sm tw-text-slate-800",
            value: String(pageSize.value),
            onChange: (e) => setPageSize(Number((e.target as HTMLSelectElement).value))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageSizeOptions, (opt) => {
              return (_openBlock(), _createElementBlock("option", {
                key: opt,
                value: String(opt)
              }, _toDisplayString(opt), 9, _hoisted_4))
            }), 128))
          ], 40, _hoisted_3)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, [
                _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-px-3 tw-py-3" }, "Name"),
                _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-px-3 tw-py-3" }, "MMSI"),
                _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-px-3 tw-py-3" })
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vessels.value, (vessel) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: vessel.id,
                  class: "tw-cursor-pointer hover:tw-bg-slate-50/70",
                  onClick: ($event: any) => (openEdit(vessel))
                }, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(vessel.name), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(vessel.mssi || '—'), 1),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/70 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-slate-800 hover:tw-bg-white",
                      onClick: _withModifiers(($event: any) => (openEdit(vessel)), ["stop"])
                    }, " Edit ", 8, _hoisted_13)
                  ])
                ], 8, _hoisted_9))
              }), 128)),
              (!_unref(loading) && vessels.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("td", {
                      colspan: "3",
                      class: "tw-px-3 tw-py-6 tw-text-center tw-text-sm tw-text-slate-500"
                    }, " No vessels found ", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("span", null, "Page " + _toDisplayString(page.value + 1) + " of " + _toDisplayString(totalPages.value), 1),
        _createElementVNode("span", null, "Showing " + _toDisplayString(vessels.value.length) + " of " + _toDisplayString(totalCount.value) + " vessels", 1)
      ]),
      (totalPages.value > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(PaginationBar, {
              page: page.value,
              totalPages: totalPages.value,
              onPreviousPage: prevPage,
              onNextPage: nextPage,
              onGoToPage: goToPage
            }, null, 8, ["page", "totalPages"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(EditVessel, {
        isOpen: isModalOpen.value,
        "onUpdate:isOpen": _cache[1] || (_cache[1] = ($event: any) => ((isModalOpen).value = $event)),
        vessel: selectedVessel.value,
        onClose: closeModal,
        onSaved: refresh
      }, null, 8, ["isOpen", "vessel"])
    ]),
    _: 1
  }, 8, ["pageSize"]))
}
}

})